import axios from 'axios'
import Cookies from 'js-cookie'

const CSRF_COOKIE_NAME = 'autosquare_openinfo_csrf_v2'

const api = axios.create({
  baseURL: '/api',
  timeout: 20000,
  withCredentials: true
})

api.interceptors.request.use((config) => {
  const method = (config.method || 'get').toLowerCase()
  if (['post', 'put', 'patch', 'delete'].includes(method)) {
    const csrfToken = Cookies.get(CSRF_COOKIE_NAME)
    if (csrfToken) {
      config.headers['X-CSRFToken'] = csrfToken
    }
  }
  return config
})

export default api
